import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    ShowButton,
    TextInput,
    SelectInput,
    BooleanInput,
    TopToolbar,
    ExportButton,
} from 'react-admin';
import { appointmentTypesFields } from '../appointment-types.model';
import { DATE_TIME_OPTIONS } from '../../app/app.component';
import LengthField from './fields/LengthField.component';
import ContactTypesField from './fields/ContactTypesField.component';

/**
 * Filters for appointment types list
 */
const appointmentTypesFilters = [
    <TextInput 
        key="name"
        source={appointmentTypesFields.name} 
        label="Name" 
        alwaysOn 
        placeholder="Search by name..."
    />,
    <SelectInput 
        key="clients_can_book"
        source={appointmentTypesFields.clientsCanBook} 
        label="Can Book"
        choices={[
            { id: 'true', name: 'Yes' },
            { id: 'false', name: 'No' },
        ]}
    />,
    <SelectInput 
        key="is_group"
        source={appointmentTypesFields.isGroup} 
        label="Type"
        choices={[
            { id: 'false', name: 'Individual' },
            { id: 'true', name: 'Group' },
        ]}
    />,
    <BooleanInput 
        key="active_only"
        source="active_only" 
        label="Active Only"
        defaultValue={true}
    />,
];

/**
 * List actions (toolbar)
 */
const ListActions = () => (
    <TopToolbar>
        <ExportButton />
    </TopToolbar>
);

/**
 * Appointment Types List Component
 * 
 * Displays list of appointment types from Healthie with filtering and sorting.
 * Read-only for Phase 1 (no create/edit/delete yet).
 */
const AppointmentTypesList = () => {
    return (
        <List
            title="Appointment Types"
            perPage={50}
            sort={{ field: appointmentTypesFields.position, order: 'ASC' }}
            filters={appointmentTypesFilters}
            actions={<ListActions />}
            filterDefaultValues={{ active_only: true }}
            sx={{
                '& .RaList-main': { margin: '0.5em' },
                '& .column-id': { width: '6%' },
                '& .column-name': { width: '18%' },
                '& .column-length': { width: '8%' },
                '& .column-available_contact_types': { width: '20%' },
                '& .column-created_at': { width: '12%' },
                '& .column-updated_at': { width: '12%' },
                '& .column-actions': { width: '8%' },
            }}
        >
            <Datagrid 
                rowClick="show" 
                bulkActionButtons={false}
            >
                <TextField 
                    source={appointmentTypesFields.id} 
                    label="ID"
                />
                <TextField 
                    source={appointmentTypesFields.name} 
                    label="Name"
                />
                <LengthField 
                    source={appointmentTypesFields.length}
                />
                <ContactTypesField 
                    source={appointmentTypesFields.availableContactTypes}
                />
                <DateField 
                    source={appointmentTypesFields.createdAt} 
                    label="Created"
                    showTime
                    options={DATE_TIME_OPTIONS}
                />
                <DateField 
                    source={appointmentTypesFields.updatedAt} 
                    label="Updated"
                    showTime
                    options={DATE_TIME_OPTIONS}
                />
                <ShowButton />
            </Datagrid>
        </List>
    );
};

export default AppointmentTypesList;

